import { appConfig } from '@/configs/appConfig.js'

export function localePath(path, locale) {
  locale = locale || appConfig.defaultLocale
  const parts = path.split('/')
  const hasLocalePrefix = parts[1] && parts[1].length === 2
  const basePath = hasLocalePrefix
    ? parts.slice(2).join('/')
    : parts[0] === '' ? parts.slice(1).join('/') : parts.join('/')
  return `/${locale}/${basePath}`
}
